import ErrorBoundary from '../components/ErrorBoundary';
import StarView from '../features/star/StarView';
import { useUiStore } from '../stores/ui';

/**
 * 项目星图页。
 *
 * Three.js 3D 星图：节点 = 任务、星座 = 任务形态聚类、星轨 = 动态光晕。
 * 读取 useUiStore().currentProjectId 决定展示哪个项目；
 * 点击节点调用 useUiStore().openTask(id) 打开详情抽屉。
 *
 * ⭐ P6.60：为星图单独加一层错误边界（compact 局部降级）。
 *    WebGL 初始化失败时（如浏览器不支持 / 显卡被禁用），只让星图区域降级为提示，
 *    不影响顶栏 / 侧栏等外壳 —— 不再出现整页白屏（P6.59 排查时即被此放大）。
 */
export default function StarPage() {
  const currentProjectId = useUiStore((s) => s.currentProjectId);
  return (
    <ErrorBoundary
      compact
      title="3D 星图不可用"
      message="当前浏览器不支持 3D 星图（WebGL 初始化失败），请使用支持 WebGL 的浏览器。其余功能不受影响。"
      resetKey={currentProjectId}
    >
      <StarView />
    </ErrorBoundary>
  );
}
